import { PlatformTeamRole } from "./platformTypes";

/**
 * How many paid seats a set of team roles consumes.
 *
 * Owners and editors consume a seat; viewers never do. The extra rule is the
 * gate: a team with no editor consumes nothing at all, so an owner working
 * alone is free, and the *first* editor therefore costs two seats rather than
 * one — the owner starts consuming at the same moment. Any arithmetic that
 * assumes a role change is worth ±1 is wrong.
 *
 * Lives in `common` so the admin server and the SPA enforce one rule rather
 * than two that can drift; `tsconfig.server.json` includes this directory.
 * Mirrors platform's own `seatCount` in SubscriptionApiService.
 */
export function countSeats(roles: PlatformTeamRole[]): number {
  if (!roles.includes("editor")) {
    return 0;
  }
  return roles.filter((role) => role === "owner" || role === "editor").length;
}
